"use client";

import { useChartContext } from "../ChartProvider";
import { ShortsworksLineChart } from "../../ShortsworksLineChart";

export const Chart = () => {
  const { chartType, data } = useChartContext();

  if (chartType === "metric") {
    return <div>Funnel Chart</div>;
  }

  if (chartType === "line") {
    return <ShortsworksLineChart data={data} />;
  }
};
